export default __webpack_public_path__ + "static/media/61_photo.8412dcb7.jpg";